import { connect } from 'react-redux'
import TopBar from './TopBar.jsx'
import { getCurrentMediaTitle } from 'redux/currentMedia/selectors'
import { getAppName } from 'redux/app/selectors'
import { isResponsiveModeEnabled } from 'redux/visualizer/selectors'

const mapStateToProps = state => ({
    title: getCurrentMediaTitle(state),
    appName: getAppName(state),
    isResponsiveModeEnabled: isResponsiveModeEnabled(state)
})

export const TopBarContainer = connect(
    mapStateToProps,
)(TopBar)
